import { createAsyncThunk } from "@reduxjs/toolkit";

import { BAND_ACTIONS, IBandUserProps } from "Bands/types";
import { BandUserService } from "Bands/services";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";
import { Dispatch } from "react";

export const dispatchGetBandUsers = (dispatch: Dispatch<any>, bandId: string) => {
  return dispatch(getBandUsers(bandId));
};

export const getBandUsers = createAsyncThunk(
  BAND_ACTIONS.getBandUsers,
  async (bandId: string, { rejectWithValue }) => {
    try {
      const data = await BandUserService.getBandUsers({
        band: API_ENDPOINTS.BAND(bandId),
      });

      // keep the key even if response is empty
      return {
        [IDataKeys.bandUser]: data.bandUser,
        meta: data.meta,
        pagination: data.pagination,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const dispatchGetMyBandUsers = (dispatch: Dispatch<any>) => {
  return dispatch(getMyBandUsers());
};

export const getMyBandUsers = createAsyncThunk(
  BAND_ACTIONS.getMyBandUsers,
  async (_, { rejectWithValue }) => {
    try {
      const data = await BandUserService.getMyBandUsers({
        itemsPerPage: 200,
      });

      // keep the key even if response is empty
      return {
        [IDataKeys.myBandUsers]: data.bandUser,
        meta: data.meta,
        pagination: data.pagination,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editBandUser = createAsyncThunk(
  BAND_ACTIONS.editBandUser,
  async (
    { bandUserId, bandUserData }: { bandUserId: string; bandUserData: IBandUserProps },
    { rejectWithValue }
  ) => {
    try {
      return await BandUserService.editBandUser(bandUserId, bandUserData);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteBandUser = createAsyncThunk(
  BAND_ACTIONS.deleteBandUser,
  async (id: string, { rejectWithValue }) => {
    try {
      return await BandUserService.deleteBandUser(id);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
